<template>
  <div class="view cart">
    <h1>{{ $t('general.label.shopping-cart') }}</h1>

    <div class="container">

      <div class="total-container" v-if="!$cart.active.readOnly">
        <dl class="total">

          <!-- TODO Jamie - Show outstanding balance when editing my booking -->

          <dt>{{ $t('general.label.subtotal') }}:</dt><dd>{{$formatter.currency($cart.active.subTotal ? $cart.active.subTotal : 0)}}</dd>
          <dt v-if="promoCodeTotal > 0">{{ promoCodeLabel }}:</dt><dd v-if="promoCodeTotal > 0" class="discount-price">({{$formatter.currency(promoCodeTotal)}})</dd>
          <dt v-if="giftCertTotal > 0">{{ giftCertLabel }}:</dt><dd v-if="giftCertTotal > 0" class="discount-price">({{$formatter.currency(giftCertTotal)}})</dd>
          <dt>{{ $t('general.label.taxes') }}:</dt><dd>{{$formatter.currency($cart.active.taxes ? $cart.active.taxes : 0)}}</dd>
          <dt v-if="$cart.active.surcharge">{{ $cart.active.surcharge.name }}:</dt><dd v-if="$cart.active.surcharge">{{ $formatter.currency($cart.active.surcharge.amount) }}</dd>
          <dt v-if="$cart.active.guestFee">{{ $t('general.label.fees') }}:</dt><dd v-if="$cart.active.guestFee">{{$formatter.currency($cart.active.guestFee)}}</dd>
          <dt class="total-label">{{ $t('general.label.total') }}:</dt><dd class="total-price">{{$formatter.currency($cart.active.total ? $cart.active.total : 0)}}</dd>
          <!-- <dt class="balance-label">{{ $t('general.label.balance') }}:</dt><dd class="balance-price">{{ $formatter.currency(balance) }}</dd> Not for inital release -->
        </dl>

        <button v-if="$cart.active.items.length && !$cart.active.readOnly" class="button-checkout" v-on:click="checkout()">
          <span v-if="balance == 0" >{{ $t('form.label.update-cart') }}</span>
          <span v-else >{{ $t('form.label.checkout') }}</span>
        </button>


        <div class="input-toggle">
            <input id="promo-toggle" class="toggle-button promo" type="checkbox">
            <label for="promo-toggle">{{ $t('cart.label.promo') }}</label>
            <p>
              <form-input v-model="$refs.promo" type="text" :label="$t('general.label.promo-code')"></form-input>
              <span class="message" :class="{ success: promoSuccess, error: !promoSuccess }">{{ promoMessage }}</span>
              <button @click="applyPromo" class="apply" :disabled="!promoButtonEnabled" :class="{processing: !promoButtonEnabled}">Apply</button>
            </p>
        </div>

        <hr />

        <div class="input-toggle">
            <input id="gc-toggle" class="toggle-button gc" type="checkbox">
            <label for="gc-toggle">{{ $t('cart.label.giftcert') }}</label>
            <p>
              <form-input v-model="$refs.gc" type="text" :label="$t('general.label.gc')"></form-input>
              <span class="message" :class="{ success: gcSuccess, error: !gcSuccess }">{{ gcMessage }}</span>
              <button @click="applyGiftCert" class="apply">Apply</button>
            </p>
        </div>
      </div>

      <div v-if="$cart.active.items.length && !$cart.active.readOnly" class="item-list">
        <cart-item v-for="item in sortedItems" :key="item.id" :item="item" :thumbnail="true"/>
      </div>
      <div class="item-list" v-else><h3>{{ $t('cart.no-items') }}</h3></div>
    </div>

    <a class="continue" v-on:click="$router.push({name: 'home'})" >{{ $t('cart.label.continue') }}</a>


    <!-- Activities you may have interest -->
    <div v-if="relatedActivities.length && !$cart.active.readOnly" class="upsell">
      <h2>{{ $t('cart.label.interest') }}</h2>
        <item-list :items="relatedActivities" type="grid"/>
    </div>

  </div>
</template>

<script>

import FormInput from '@/components/FormInput.vue'
import Activity from '@/models/Activity.js'
import CartItem from '@/components/CartItem.vue'
import Cart from '@/models/Cart';
import ItemList from '@/components/ItemList.vue'

export default {

  data() {
    return {
      breadcrumbLabel: this.$t('cart.label.cart'),
      promoMessage: "",
      gcMessage: "",
      promoButtonEnabled: true,
      promoSuccess: false,
      gcButtonEnabled: true,
      gcSuccess: false,
      relatedActivities: []
    }
  },

  components: {
    CartItem,
    FormInput,
    ItemList
  },

  created(){
    this.updateRelatedActivities();
  },

  computed: {
    sortedItems(){
      return this.$cart.active.items.slice().sort((a, b) => {
        let aDate = new Date(a.date + " " + (a.startTime != "00:00:00" ? a.startTime : a.rentalStartTime));
        let bDate = new Date(b.date + " " + (b.startTime != "00:00:00" ? b.startTime : b.rentalStartTime));
        return aDate-bDate;
      })
    },

    balance() {
      // TODO: Add balance calculation based off of totals and promos/gift certs
      return this.$cart.active.total ? this.$cart.active.total : 0;
    },

    promoCodeLabel() {
      let promoCodeName = this.$cart.active.appliedPromoCodes ? this.$cart.active.appliedPromoCodes.promoCodes[0].label : '';
      return this.$t('general.label.promo-code') + ` (${ promoCodeName })`;
    },

    promoCodeTotal() {
      return this.$cart.active.appliedPromoCodes ? this.$cart.active.appliedPromoCodes.totalPromoAmount : 0;
    },

    giftCertLabel() {
      let giftCertName = this.$cart.active.appliedGiftCerts ? this.$cart.active.appliedGiftCerts.giftCerts[0].label : '';
      return this.$t('general.label.gc') + ` (${ giftCertName })`;
    },

    giftCertTotal() {
      return this.$cart.active.appliedGiftCerts ? this.$cart.active.appliedGiftCerts.totalGiftCertAmount : 0;
    }
  },

  watch: {
    '$cart.active.related_oftenBoughtTogether': function(newVal){
      this.updateRelatedActivities();
    }
  },
  methods: {
    checkout(){
      this.$router.push({name: 'checkout'});
    },
    updateRelatedActivities(){
      var vm = this;
      vm.relatedActivities = [];
      if (vm.$cart.active.related_oftenBoughtTogether){
        vm.$cart.active.related_oftenBoughtTogether.activities.forEach((item) => {
          Activity.fetch(item.tourId).then(() => {
            vm.relatedActivities.push(Activity.query().whereId(item.tourId).first());
          });
        });
      }
    },
    applyPromo(){
      this.promoMessage = "";
      this.promoButtonEnabled = false;

      Cart.applyPromoCode({promo: this.$refs.promo}).then(response => {
        if (response.success){
          this.promoSuccess = true;
          this.promoMessage = this.$t(`promo-code.${response.message}`);

          // refresh cart
          Cart.load();
        } else {
          this.promoSuccess = false;
          this.promoMessage = this.$t(`promo-code.${response.error.translation}`);
        }
      }).catch(err => {

      }).finally(() => {
        this.promoButtonEnabled = true;
      });
    },
    applyGiftCert(){
      this.gcMessage = "";
      Cart.applyGiftCert({giftCert: this.$refs.gc}).then(response => {
        if (response.success){
          this.gcSuccess = true;
          this.gcMessage = this.$t(`giftcert.${response.message}`);

          // refresh cart
          Cart.load();
        } else {
          this.gcSuccess = false;
          this.gcMessage = this.$t(`giftcert.${response.error.translation}`);
        }
      }).catch(err => {

      });
    }
  }
};
</script>

<style lang="scss">
.view.cart {
  @include breakpoint(medium) {
    .container {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }
  }

  .form-input > .input{
    > input {
      padding-left: 15px !important;
    }
    > label {
      padding-left: 0 !important;
    }
  }

  .button-checkout {
    @include button($colorCTA, #fff);
    width: 100%;
    margin-bottom: 10px;
  }

  .total-container {
    @include breakpoint(medium) {
      width: 300px;
      order: 2;
      background-color: $colorBgGray;
      padding: 10px 25px 15px 25px;
      position: sticky;
      top: 75px;
    }

    .total {
      text-align: right;
      @include font-small;
      display: grid;
      grid-template-columns: auto 50%;
      color: $colorGray;

      dt {
        text-align: left;
        padding-right: 25px;
      }

      dd {
        margin: 0;
      }

      /*  IE */
      @media all and (-ms-high-contrast:none) {
        @include clearfix;
        dt {
          clear: both;
          float: left;
        }
        dd {
          float: right;
        }
      }

      .total-label,
      .total-price {
        font-size: 20px;
        font-weight: 500;
        line-height: 33px;
        color: $colorDefault;
      }

      .balance-label,
      .balance-price {
        font-size: 20px;
        font-weight: 500;
        line-height: 27px;
        color: $colorRed;
      }

      .discount-price {
        color: $colorRed;
      }
    }

    .promo,
    .gift {
      text-align: center;
      margin: 10px 0;
    }
  }


  .item-list {
    margin-top: 25px;
    @include breakpoint(medium) {
      width: calc(100% - 330px);
      margin-right: 30px;
      order: 1;
      margin-top: 0;
    }
     > ol > li {
      max-width: 50%;
      flex: 0 0 50%;
      padding: 0 0.5em 0 0.5em;
     }
  }

  .continue {
    display: inline-block;
    margin: 10px 0;

    &::before {
      @include font-awesome-pseudo($fa-var-chevron-left, light);
      margin-right: 8px;
    }
  }

  .toggle-button {
    display: none;

    + label {
      color: $colorBlue;
      align-items: center;
      cursor: pointer;
      &:hover {
        filter: brightness(1.3);
        // color: lighten($colorBlue, 10);
      }

      &::before {
        content: none !important;
      }

      &::after {
        @include font-awesome-pseudo($fa-var-chevron-down, light);
        margin-left: 5px;
      }
    }

    ~ p {
      margin-bottom: 0;
      max-height: 0;
      overflow: hidden;
      padding-top: 0px;
    }

    &:checked {
      + label::after {
        transform: rotate(-180deg);
      }

      ~ p {
        max-height: 400px;
        padding-top: 10px;
        transition: all .2s;
        text-align: center;
      }
    }
  }

  .input-toggle {
    text-align: left;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  hr {
    border-top: 1px solid $colorPaleGray;
  }

  .apply {
    @include button($colorCTA, #fff);
    width: 50%;
    margin-bottom: 5px;
  }

  .success {
    color: $colorGreen;
  }

  .message {
    display: block;
    margin-bottom: 20px;
  }

  .processing {
    opacity: 0.60;
    cursor: not-allowed;
  }

  // Upsell area
  .upsell {
    @include full-width;
    background-color: $colorBgGray;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    margin-top: 30px;
    @include breakpoint(medium) {
      background-color: #fff;
      margin-top: 40px;
    }

    h2 {
      margin-bottom: 15px;
    }
  }

  .activities {
    @include grid-list;
    @include breakpoint(medium) {
      margin: 0 -8px;
    }

    ol li {
      margin-bottom: 25px;
    }

    .activity-list {
      display: flex;
      box-shadow: 0 1px 5px 1px rgba(0,0,0,0.2);
      color: #222;
      background-color: #fff;
      @include breakpoint(medium) {
        flex-wrap: wrap;
        height: 100%;
        align-content: flex-start;
      }
    }

    .activity-image {
      object-fit: cover;
      width: 100px;
      height: 100px;
      @include breakpoint(medium) {
        height: 185px;
        width: 100%;
      }
    }

    .activity-info {
      padding: 12px;
      width: 100%;
    }

    .activity-name {
      @include font-h3;
      margin-bottom: 5px;
    }

    .activity-icons {
      @include item-list-icons;
    }

    .activity-price {
      @include font-h2;
      @include breakpoint(medium) {
        text-align: right;
      }

      .from {
        @include from;
        margin-right: 5px;
      }
    }
  }
}
</style>